import { render, staticRenderFns } from "./ConfirmTask.vue?vue&type=template&id=63d8e18b"
import script from "./ConfirmTask.vue?vue&type=script&lang=js"
export * from "./ConfirmTask.vue?vue&type=script&lang=js"
import style0 from "./ConfirmTask.vue?vue&type=style&index=0&id=63d8e18b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports